import config from "src/config.js";
import { BaseAuth } from "./base-auth.js";
import { KeyCloakAuth } from "./keycloak-auth.js";
import { MidAuth } from "./mid-auth.js";

export class AuthService {
    /**
     * Constructor
     */
    constructor() {
        const authType = config.env("VITE_AUTH_TYPE");
        if (authType === "mid2") {
            this.auth = new MidAuth();
        } else if (authType === "keycloak") {
            this.auth = new KeyCloakAuth();
        } else {
            this.auth = new BaseAuth();
        }
    }
}
